import React from "react"
import CTA from "../UI/CTA"
import IntroSection from "../UI/IntroSection"
import InfoWithImageSection from "../UI/InfoWithImageSection"

const FinancingDesktop: React.FC = () => {
    return (
        <main>
            <IntroSection title="Financiamento" text="" img="https://gabcomercio.azureedge.net/azul-agro/desktop/financing/introSection.webp" alignItems="flex-start" justifyContent="flex-end" lineInverted />
            <CTA href="/financiamento/contato" text="Quer saber mais sobre o financiamento? Solicite a visita de um consultor." />
            <InfoWithImageSection title={"Banco CNH"} text={"Banco CNH Industrial. O banco de quem PRODUZ, CONSTRÓI E TRANSPORTA. Banco de fábrica da New Holland e nosso maior suporte no processo de financiamento de equipamentos agrícolas. Com o intuito de atender todos os portes de produtores, traz as principais linhas de financiamento BNDES como Moderfrota*, Pronaf* e linhas especiais como CDC. É agilidade no crédito ao produtor."} img={"https://gabcomercio.azureedge.net/azul-agro/general/financing/img1.webp"} width={530} height={600} hasButton href="/financiamento/contato" />
        </main>
    )
}

export default React.memo(FinancingDesktop)
